var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.03 11.6699L19.8 9.89992L9.9 -7.82013e-05L0 9.89992L1.77 11.6699L9.9 3.53992L18.03 11.6699Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbUpArrow);
export default __webpack_public_path__ + "static/media/SBUpArrow.ede1ac3f479aeb02e242c871c5ebe135.svg";
export { ForwardRef as ReactComponent };